import React, { useState } from 'react';
import { FaTruck, FaBox, FaMapMarkerAlt, FaSearch } from 'react-icons/fa';
import { MdOutlineInventory2 } from "react-icons/md";
import { trackContact } from '../helpers/analyticsHelper';

const TrackOrder = () => {
 const [orderId, setOrderId] = useState('');
 const [trackingResult, setTrackingResult] = useState(null);
 const [isLoading, setIsLoading] = useState(false);

 const handleTrack = (e) => {
 e.preventDefault();
 if (!orderId) return;

 setIsLoading(true);

 // Dummy timeout to simulate API loading for UI purposes
 setTimeout(() => {
 setTrackingResult({
 id: orderId,
 status: 'in_transit', // 'processing', 'shipped', 'in_transit', 'delivered'
 estimatedDelivery: 'Oct 24, 2026',
 address: '123 Farmer Road, Green Valley District, Punjab, India',
 items: [
 { name: 'bayer roundup herbicide (glyphosate 41% sl)', qty: 1, price: 158.00 },
 { name: 'saaf fungicide', qty: 3, price: 267.00 }
 ],
 events: [
 { status: 'Order Placed', date: 'Oct 18, 2026, 10:00 AM', location: 'Website', done: true },
 { status: 'Processing', date: 'Oct 19, 2026, 02:30 PM', location: 'Delhi Warehouse', done: true },
 { status: 'Shipped', date: 'Oct 20, 2026, 08:45 AM', location: 'Delhi Facility', done: true },
 { status: 'In Transit', date: 'Oct 21, 2026, 11:20 AM', location: 'Ludhiana Hub', done: true, current: true },
 { status: 'Out for Delivery', date: 'Pending', location: '-', done: false },
 { status: 'Delivered', date: 'Pending', location: '-', done: false },
 ]
 });
 setIsLoading(false);
 }, 1500);
 };

 return (
 <div className="bg-[#f0f4f2] pt-6 pb-24 px-4 font-sans flex justify-center items-start">
 {/* SINGLE MAIN BOX WRAPPER - Profile Aesthetic */}
 <div className="w-full max-w-5xl bg-white rounded-[32px] shadow-2xl overflow-hidden flex flex-col">

 {/* HEADER - Profile-like Dark Green Gradient */}
 <div className='bg-gradient-to-r from-[#143d2c] to-[#0d2a1f] px-6 lg:px-12 py-10 relative overflow-hidden shrink-0'>
 <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-16 translate-x-16 mix-blend-screen pointer-events-none"></div>
 <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#00b259]/20 rounded-full blur-2xl pointer-events-none"></div>

 <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
 <div className="flex items-center gap-5">
 <div className="w-16 h-16 rounded-full bg-white/10 border-2 border-[#00b259] flex items-center justify-center text-white shadow-lg backdrop-blur-md">
 <FaMapMarkerAlt size={28} />
 </div>
 <div>
 <h1 className="text-3xl lg:text-4xl font-black text-white tracking-widest uppercase">
 Track Order
 </h1>
 <p className="text-[#00b259] font-bold text-sm tracking-widest mt-1 uppercase">
 Real-time Shipping Status
 </p>
 </div>
 </div>

 {/* Integrated Search Bar */}
 <form onSubmit={handleTrack} className="w-full md:w-auto md:min-w-[400px] relative group h-[52px] flex shadow-lg rounded-full">
 <input
 type="text"
 placeholder="Order ID (e.g. FSL-7932)"
 value={orderId}
 onChange={(e) => setOrderId(e.target.value)}
 className="w-full h-full bg-white text-[#143d2c] placeholder-gray-400 text-[15px] font-bold rounded-l-full pl-6 pr-4 outline-none border border-white focus:border-[#00b259] transition-all"
 />
 <button
 type="submit"
 disabled={!orderId || isLoading}
 className="h-full bg-[#00b259] hover:bg-[#009b4d] text-white font-black px-8 rounded-r-full uppercase tracking-widest transition-all disabled:bg-gray-300 disabled:text-gray-500 flex items-center justify-center border border-[#00b259] disabled:border-gray-300"
 >
 {isLoading ? (
 <div className="w-5 h-5 border-[3px] border-white border-t-transparent rounded-full animate-spin"></div>
 ) : (
 <FaSearch size={18} />
 )}
 </button>
 </form>
 </div>
 </div>

 {/* CONTENT BODY */}
 <div className="p-6 lg:p-10 relative min-h-[400px] bg-[#f8fcfb]">
 {!trackingResult && !isLoading && (
 <div className="flex flex-col items-center justify-center h-full text-center py-20 opacity-60 transition-opacity duration-300">
 <div className="w-24 h-24 bg-green-50 rounded-full flex items-center justify-center mb-6">
 <FaBox className="text-[#00b259]/40" size={50} />
 </div>
 <h2 className="text-xl font-black text-[#143d2c] tracking-wide mb-2">Awaiting Order Number</h2>
 <p className="text-gray-500 max-w-sm text-sm font-medium">Please input your FasalShop order ID above to begin tracking the live fulfillment journey.</p>
 </div>
 )}

 {/* TRACKING RESULT - LEFT/RIGHT LAYOUT INSIDE THE BOX */}
 {trackingResult && (
 <div className="flex flex-col lg:flex-row gap-0 lg:gap-10 transition-opacity duration-500 opacity-100 items-start">

 {/* LEFT MAIN: TIMELINE */}
 <div className="flex-[2] w-full flex flex-col pt-2 border-b lg:border-b-0 lg:border-r border-gray-100 lg:pr-10 pb-10 lg:pb-0">

 {/* Status Briefly */}
 <div className="flex justify-between items-center mb-8 bg-[#e6f7ef] px-6 py-4 rounded-2xl border border-green-100">
 <div>
 <p className="text-[#00b259]/60 font-black text-[10px] uppercase tracking-[3px] mb-1">Status</p>
 <h2 className="text-[#00b259] font-black text-lg uppercase tracking-wider">{trackingResult.status.replace('_', ' ')}</h2>
 </div>
 <div className="text-right">
 <p className="text-[#00b259]/60 font-black text-[10px] uppercase tracking-[3px] mb-1">Order #</p>
 <span className="text-[#143d2c] font-black text-md tracking-wider">
 {trackingResult.id}
 </span>
 </div>
 </div>

 <div className="flex-1 pl-2">
 <h3 className="text-[#1a1a1a] font-black text-[13px] uppercase tracking-[3px] mb-8 text-gray-400">
 Fulfillment Timeline
 </h3>

 <div className="relative ml-4 md:ml-6 space-y-0">
 {/* Continuous vertical line */}
 <div className="absolute top-2 bottom-6 left-[-15px] border-l-4 border-gray-100"></div>

 {trackingResult.events.map((event, idx) => (
 <div key={idx} className="relative pl-8 md:pl-10 pb-8 group">
 {/* Step point */}
 <div className={`absolute -left-[25px] top-0 w-6 h-6 rounded-full border-[4px] flex items-center justify-center align-middle bg-white z-10 transition-all duration-300
 ${event.done ? 'border-[#00b259]' : 'border-gray-200'}
 ${event.current && 'ring-8 ring-[#00b259]/10 border-[#00b259] scale-125'}
 `}></div>

 <div className={`flex flex-col sm:flex-row sm:justify-between items-start gap-2 p-4 rounded-2xl transition-colors border
 ${event.done ? (event.current ? 'bg-white border-green-100 shadow-sm' : 'bg-transparent border-transparent hover:bg-white') : 'bg-transparent border-transparent opacity-50'}
 `}>
 <div>
 <h4 className={`text-[15px] font-black tracking-tight mb-1 ${event.done ? 'text-[#143d2c]' : 'text-gray-400'}`}>
 {event.status}
 </h4>
 <p className="text-[12px] text-gray-500 font-medium flex items-center gap-2">
 <FaMapMarkerAlt className={event.done ? "text-[#f39200]" : "text-gray-300"} />
 {event.location}
 </p>
 </div>
 <div className="flex items-center">
 <span className={`text-[10px] font-black tracking-widest uppercase px-3 py-1.5 rounded-lg ${event.done ? 'bg-gray-50 text-gray-500' : 'text-gray-400'}`}>
 {event.date}
 </span>
 </div>
 </div>
 </div>
 ))}
 </div>
 </div>
 </div>

 {/* RIGHT INFO BAR */}
 <div className="flex-[1] w-full flex flex-col gap-6 lg:sticky lg:top-10 h-fit pt-8 lg:pt-0">

 {/* Estimated Delivery Focus */}
 <div className="text-center p-6 border-b border-gray-100">
 <MdOutlineInventory2 size={36} className="text-[#00b259] mx-auto mb-3" />
 <p className="text-gray-400 font-black text-[10px] uppercase tracking-[4px] mb-2">Estimated Arrival</p>
 <h3 className="text-3xl font-black tracking-tighter text-[#143d2c]">{trackingResult.estimatedDelivery}</h3>

 <div className="w-full bg-gray-100 h-1.5 rounded-full overflow-hidden mt-6 mb-2">
 <div className="bg-[#00b259] h-full rounded-full w-[75%]"></div>
 </div>
 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest text-right">75% Completed</p>
 </div>

 {/* Address Section */}
 <div className="px-4">
 <h4 className="text-gray-400 font-black text-[10px] uppercase tracking-[3px] mb-3 flex items-center gap-2">
 <FaMapMarkerAlt className="text-gray-300" /> Destination
 </h4>
 <p className="text-[#143d2c] text-[13px] font-bold leading-relaxed bg-white border border-gray-100 p-4 rounded-xl shadow-sm">
 {trackingResult.address}
 </p>
 </div>

 {/* Items Box */}
 <div className="px-4">
 <h4 className="text-gray-400 font-black text-[10px] uppercase tracking-[3px] mb-3">Package Contents</h4>
 <div className="space-y-2 bg-white border border-gray-100 p-4 rounded-xl shadow-sm">
 {trackingResult.items.map((item, i) => (
 <div key={i} className="flex gap-3 items-center">
 <div className="w-6 h-6 rounded bg-gray-50 flex items-center justify-center text-[10px] font-black text-gray-400 flex-shrink-0">
 {item.qty}x
 </div>
 <span className="text-[11px] font-bold uppercase tracking-wider text-[#143d2c] leading-snug line-clamp-1">
 {item.name}
 </span>
 </div>
 ))}
 </div>
 </div>

 <div className="mt-2 px-4">
 <a
     href={`https://wa.me/916266761336?text=${encodeURIComponent(`Hello FasalShop Support, I need help with my order tracking (Order ID: ${trackingResult?.id || orderId}).`)}`}
     target='_blank'
     rel='noopener noreferrer'
     onClick={() => trackContact({ method: 'WhatsApp', location: 'Track Order Page Help' })}
     className="w-full bg-[#f4f7f5] text-[#143d2c] hover:bg-[#e6f7ef] hover:text-[#00b259] py-3.5 rounded-xl font-black text-[11px] uppercase tracking-[2px] transition-colors border border-green-50 shadow-sm flex justify-center items-center gap-2 group cursor-pointer"
 >
     <FaTruck className="group-hover:translate-x-1 transition-transform" /> Contact Courier Help
 </a>
 </div>

 </div>
 </div>
 )}
 </div>
 </div>
 </div>
 );
};

export default TrackOrder;
